import React from 'react';

const TaskView = () => {
	return (
		<div className="body-content task-contetn bg-white">
			{/* <div className="top-header bg-white">
				<div className="d-flex align-items-center justify-content-between">
					<div className="top-header-left">
						<p className="medium-14 gray_dark_02 weight-500">22 Project</p>
					</div>
					<div className="top-header-right">
						<div class="filter-actions compare-filter-actions">
							<div class="form-group size32 m-0 mr-1 search-filter filter-with-animation">
								<div class="with-icon right-icon hidden">
									<input type="text" placeholder="Search" />
									<span class="right-icon">
										<CommonImage src="/icons/search.png" />
									</span>
								</div>
							</div>
							<div class="add-new-task">
								<button class="button text size32 px-0">
									<CommonImage src="icons/add-round.svg" />
									<span class="ml-1 gray_dark_01">Project</span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div> */}
			<div className="task-list-container">
				<div className="task-all-row d-grid gap-5 grid-columns-4">
					<div className="task-column task-not-started">
						<div className="task-column-header d-flex align-items-center justify-content-start">
							<p className="d-flex align-items-center regular-16 gray_dark_01 weight-500">
								<span className="round-dot mr-2"></span> Not started
							</p>
							<span className="circel-count gray_dark_02 ml-2">4</span>
						</div>
						<div className="task-column-body">
							{/* single-box */}
							<div className="single-task-box mb-3">
								<div className="header-and-dropdown d-flex align-items-center justify-content-between">
									<p className="gray_dark_01 regular-16 weight-500">Project name</p>
									<div className="option">
										<div className="dropdown">
											<button
												className="btn btn-default dropdown-toggle"
												type="button"
												id="menu1"
												data-toggle="dropdown"
												aria-expanded="false"
											>
												<img src="/icons/more_icon.svg" alt="" />
											</button>
											<ul
												className="dropdown-menu dropdown-menu-right shadow-lg"
												role="menu"
												aria-labelledby="menu1"
												x-placement="bottom-end"
											>
												<li role="presentation" className="px-4 pb-3 pt-3">
													<a
														role="menuitem"
														tabIndex={-1}
														className="font-weight-normal  text-black"
														href="/invoices/edit/10052"
													>
														Edit
													</a>
												</li>
												<li role="presentation" className="px-4 pb-3">
													<a
														role="menuitem"
														tabIndex={-1}
														className="font-weight-normal  text-black"
														href
													>
														Delete
													</a>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="task-box-content mt-2">
									<ul>
										<li className="medium-14 gray_dark_02 weight-500 pb-1">
											Owner:<span className="gray_dark_01 ml-1">John Doe</span>
										</li>
										<li className="medium-14 gray_dark_02 weight-500">
											Timeline:<span className="gray_dark_01 ml-1">In Progress</span>
										</li>
									</ul>
									<div className="progress-info mt-2 d-flex align-items-center justify-content-start">
										<div className="progress progress-square">
											<div className="progress-bar" style={{ width: '40%' }}></div>
										</div>
										<div className="progress-text ml-2">
											<p className="regular-14 gray_dark_01">4/10</p>
										</div>
									</div>
									<div className="add-member-and-unread-count d-flex align-items-center justify-content-between">
										<div class="add-member add-buyer">
											<div class="added-members px-0">
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="Sadat"
												/>
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="Mamun"
												/>
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="Zahinul Haque"
												/>
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="pm"
												/>
												<div class="more-people">
													<a href="#">+1</a>
												</div>
											</div>
										</div>
										<div class="unread-message">
											<p className="weight-500">12</p>
										</div>
									</div>
								</div>
							</div>
							{/* single-box */}
							<div className="single-task-box">
								<div className="header-and-dropdown d-flex align-items-center justify-content-between">
									<p className="gray_dark_01 regular-16 weight-500">Project name</p>
									<div className="option">
										<div className="dropdown">
											<button
												className="btn btn-default dropdown-toggle"
												type="button"
												id="menu1"
												data-toggle="dropdown"
												aria-expanded="false"
											>
												<img src="/icons/more_icon.svg" alt="" />
											</button>
											<ul
												className="dropdown-menu dropdown-menu-right shadow-lg"
												role="menu"
												aria-labelledby="menu1"
												x-placement="bottom-end"
											>
												<li role="presentation" className="px-4 pb-3 pt-3">
													<a
														role="menuitem"
														tabIndex={-1}
														className="font-weight-normal  text-black"
														href="/invoices/edit/10052"
													>
														Edit
													</a>
												</li>
												<li role="presentation" className="px-4 pb-3">
													<a
														role="menuitem"
														tabIndex={-1}
														className="font-weight-normal  text-black"
														href
													>
														Delete
													</a>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="task-box-content mt-2">
									<ul>
										<li className="medium-14 gray_dark_02 weight-500 pb-1">
											Owner:<span className="gray_dark_01 ml-1">John Doe</span>
										</li>
										<li className="medium-14 gray_dark_02 weight-500">
											Timeline:<span className="gray_dark_01 ml-1">In Progress</span>
										</li>
									</ul>
									<div className="progress-info task-progress-info mt-2 d-flex align-items-center justify-content-start">
										<div className="progress progress-square">
											<div className="progress-bar" style={{ width: '40%' }}></div>
										</div>
										<div className="progress-text ml-2">
											<p className="regular-14 gray_dark_01">4/10</p>
										</div>
									</div>
									<div className="add-member-and-unread-count d-flex align-items-center justify-content-between">
										<div class="add-member add-buyer">
											<div class="added-members px-0">
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="Sadat"
												/>
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="Mamun"
												/>
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="Zahinul Haque"
												/>
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="pm"
												/>
												<div class="more-people">
													<a href="#">+1</a>
												</div>
											</div>
										</div>
										<div class="unread-message">
											<p className="weight-500">12</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="task-column task-running">
						<div className="task-column-header d-flex align-items-center justify-content-start">
							<p className="d-flex align-items-center regular-16 gray_dark_01 weight-500">
								<span className="round-dot mr-2"></span> Not started
							</p>
							<span className="circel-count gray_dark_02 ml-2">4</span>
						</div>
						<div className="task-column-body">
							{/* single-box */}
							<div className="single-task-box mb-3">
								<div className="header-and-dropdown d-flex align-items-center justify-content-between">
									<p className="gray_dark_01 regular-16 weight-500">Project name</p>
									<div className="option">
										<div className="dropdown">
											<button
												className="btn btn-default dropdown-toggle"
												type="button"
												id="menu1"
												data-toggle="dropdown"
												aria-expanded="false"
											>
												<img src="/icons/more_icon.svg" alt="" />
											</button>
											<ul
												className="dropdown-menu dropdown-menu-right shadow-lg"
												role="menu"
												aria-labelledby="menu1"
												x-placement="bottom-end"
											>
												<li role="presentation" className="px-4 pb-3 pt-3">
													<a
														role="menuitem"
														tabIndex={-1}
														className="font-weight-normal  text-black"
														href="/invoices/edit/10052"
													>
														Edit
													</a>
												</li>
												<li role="presentation" className="px-4 pb-3">
													<a
														role="menuitem"
														tabIndex={-1}
														className="font-weight-normal  text-black"
														href
													>
														Delete
													</a>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="task-box-content mt-2">
									<ul>
										<li className="medium-14 gray_dark_02 weight-500 pb-1">
											Owner:<span className="gray_dark_01 ml-1">John Doe</span>
										</li>
										<li className="medium-14 gray_dark_02 weight-500">
											Timeline:<span className="gray_dark_01 ml-1">In Progress</span>
										</li>
									</ul>
									<div className="progress-info mt-2 d-flex align-items-center justify-content-start">
										<div className="progress progress-square">
											<div className="progress-bar" style={{ width: '40%' }}></div>
										</div>
										<div className="progress-text ml-2">
											<p className="regular-14 gray_dark_01">4/10</p>
										</div>
									</div>
									<div className="add-member-and-unread-count d-flex align-items-center justify-content-between">
										<div class="add-member add-buyer">
											<div class="added-members px-0">
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="Sadat"
												/>
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="Mamun"
												/>
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="Zahinul Haque"
												/>
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="pm"
												/>
												<div class="more-people">
													<a href="#">+1</a>
												</div>
											</div>
										</div>
										<div class="unread-message">
											<p className="weight-500">12</p>
										</div>
									</div>
								</div>
							</div>
							{/* single-box */}
							<div className="single-task-box">
								<div className="header-and-dropdown d-flex align-items-center justify-content-between">
									<p className="gray_dark_01 regular-16 weight-500">Project name</p>
									<div className="option">
										<div className="dropdown">
											<button
												className="btn btn-default dropdown-toggle"
												type="button"
												id="menu1"
												data-toggle="dropdown"
												aria-expanded="false"
											>
												<img src="/icons/more_icon.svg" alt="" />
											</button>
											<ul
												className="dropdown-menu dropdown-menu-right shadow-lg"
												role="menu"
												aria-labelledby="menu1"
												x-placement="bottom-end"
											>
												<li role="presentation" className="px-4 pb-3 pt-3">
													<a
														role="menuitem"
														tabIndex={-1}
														className="font-weight-normal  text-black"
														href="/invoices/edit/10052"
													>
														Edit
													</a>
												</li>
												<li role="presentation" className="px-4 pb-3">
													<a
														role="menuitem"
														tabIndex={-1}
														className="font-weight-normal  text-black"
														href
													>
														Delete
													</a>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="task-box-content mt-2">
									<ul>
										<li className="medium-14 gray_dark_02 weight-500 pb-1">
											Owner:<span className="gray_dark_01 ml-1">John Doe</span>
										</li>
										<li className="medium-14 gray_dark_02 weight-500">
											Timeline:<span className="gray_dark_01 ml-1">In Progress</span>
										</li>
									</ul>
									<div className="progress-info mt-2 d-flex align-items-center justify-content-start">
										<div className="progress progress-square">
											<div className="progress-bar" style={{ width: '40%' }}></div>
										</div>
										<div className="progress-text ml-2">
											<p className="regular-14 gray_dark_01">4/10</p>
										</div>
									</div>
									<div className="add-member-and-unread-count d-flex align-items-center justify-content-between">
										<div class="add-member add-buyer">
											<div class="added-members px-0">
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="Sadat"
												/>
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="Mamun"
												/>
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="Zahinul Haque"
												/>
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="pm"
												/>
												<div class="more-people">
													<a href="#">+1</a>
												</div>
											</div>
										</div>
										<div class="unread-message">
											<p className="weight-500">12</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="task-column task-complete">
						<div className="task-column-header d-flex align-items-center justify-content-start">
							<p className="d-flex align-items-center regular-16 gray_dark_01 weight-500">
								<span className="round-dot mr-2"></span> Not started
							</p>
							<span className="circel-count gray_dark_02 ml-2">4</span>
						</div>
						<div className="task-column-body">
							{/* single-box */}
							<div className="single-task-box mb-3">
								<div className="header-and-dropdown d-flex align-items-center justify-content-between">
									<p className="gray_dark_01 regular-16 weight-500">Project name</p>
									<div className="option">
										<div className="dropdown">
											<button
												className="btn btn-default dropdown-toggle"
												type="button"
												id="menu1"
												data-toggle="dropdown"
												aria-expanded="false"
											>
												<img src="/icons/more_icon.svg" alt="" />
											</button>
											<ul
												className="dropdown-menu dropdown-menu-right shadow-lg"
												role="menu"
												aria-labelledby="menu1"
												x-placement="bottom-end"
											>
												<li role="presentation" className="px-4 pb-3 pt-3">
													<a
														role="menuitem"
														tabIndex={-1}
														className="font-weight-normal  text-black"
													>
														Edit
													</a>
												</li>
												<li role="presentation" className="px-4 pb-3">
													<a
														role="menuitem"
														tabIndex={-1}
														className="font-weight-normal  text-black"
													>
														Delete
													</a>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="task-box-content mt-2">
									<ul>
										<li className="medium-14 gray_dark_02 weight-500 pb-1">
											Owner:<span className="gray_dark_01 ml-1">John Doe</span>
										</li>
										<li className="medium-14 gray_dark_02 weight-500">
											Timeline:<span className="gray_dark_01 ml-1">In Progress</span>
										</li>
									</ul>
									<div className="progress-info mt-2 d-flex align-items-center justify-content-start">
										<div className="progress progress-square">
											<div className="progress-bar" style={{ width: '40%' }}></div>
										</div>
										<div className="progress-text ml-2">
											<p className="regular-14 gray_dark_01">4/10</p>
										</div>
									</div>
									<div className="add-member-and-unread-count d-flex align-items-center justify-content-between">
										<div class="add-member add-buyer">
											<div class="added-members px-0">
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="Sadat"
												/>
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="Mamun"
												/>
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="Zahinul Haque"
												/>
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="pm"
												/>
												<div class="more-people">
													<a href="#">+1</a>
												</div>
											</div>
										</div>
										<div class="unread-message">
											<p className="weight-500">12</p>
										</div>
									</div>
								</div>
							</div>
							{/* single-box */}
							<div className="single-task-box">
								<div className="header-and-dropdown d-flex align-items-center justify-content-between">
									<p className="gray_dark_01 regular-16 weight-500">Project name</p>
									<div className="option">
										<div className="dropdown">
											<button
												className="btn btn-default dropdown-toggle"
												type="button"
												id="menu1"
												data-toggle="dropdown"
												aria-expanded="false"
											>
												<img src="/icons/more_icon.svg" alt="" />
											</button>
											<ul
												className="dropdown-menu dropdown-menu-right shadow-lg"
												role="menu"
												aria-labelledby="menu1"
												x-placement="bottom-end"
											>
												<li role="presentation" className="px-4 pb-3 pt-3">
													<a
														role="menuitem"
														tabIndex={-1}
														className="font-weight-normal  text-black"
														href="/invoices/edit/10052"
													>
														Edit
													</a>
												</li>
												<li role="presentation" className="px-4 pb-3">
													<a
														role="menuitem"
														tabIndex={-1}
														className="font-weight-normal  text-black"
														href
													>
														Delete
													</a>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="task-box-content mt-2">
									<ul>
										<li className="medium-14 gray_dark_02 weight-500 pb-1">
											Owner:<span className="gray_dark_01 ml-1">John Doe</span>
										</li>
										<li className="medium-14 gray_dark_02 weight-500">
											Timeline:<span className="gray_dark_01 ml-1">In Progress</span>
										</li>
									</ul>
									<div className="progress-info mt-2 d-flex align-items-center justify-content-start">
										<div className="progress progress-square">
											<div className="progress-bar" style={{ width: '40%' }}></div>
										</div>
										<div className="progress-text ml-2">
											<p className="regular-14 gray_dark_01">4/10</p>
										</div>
									</div>
									<div className="add-member-and-unread-count d-flex align-items-center justify-content-between">
										<div class="add-member add-buyer">
											<div class="added-members px-0">
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="Sadat"
												/>
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="Mamun"
												/>
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="Zahinul Haque"
												/>
												<img
													src=" /images/alave.png"
													alt=""
													data-toggle="tooltip"
													data-placement="top"
													data-original-title="pm"
												/>
												<div class="more-people">
													<a href="#">+1</a>
												</div>
											</div>
										</div>
										<div class="unread-message">
											<p className="weight-500">12</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TaskView;
